export default __webpack_public_path__ + "static/media/img (2).a246895e.jpg";